var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKrookieJournal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62122 1.40032C5.8828 1.14369 6.23412 1 6.59998 1H27.5999C28.3731 1 28.9999 1.62887 28.9999 2.40464L29 18.2141C29 18.9899 28.3732 19.6187 27.6 19.6187C26.8268 19.6187 26.2 18.9899 26.2 18.2141L26.1999 3.80935H7.17068L3.79999 7.11616V26.1906H7.99997C8.77317 26.1906 9.39997 26.8195 9.39997 27.5953C9.39997 28.3711 8.77317 29 7.99997 29H2.39999C1.6268 29 1 28.3711 1 27.5953V6.52506C1 6.14705 1.15185 5.78498 1.42123 5.52071L5.62122 1.40032Z",
    fill: "#58486C",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60001 2.4043C5.82681 2.4043 5.20001 3.03319 5.20001 3.80897V5.21365H3.80002C3.02682 5.21365 2.40002 5.84255 2.40002 6.61833C2.40002 7.39411 3.02682 8.023 3.80002 8.023H6.60001C7.3732 8.023 8 7.39411 8 6.61833V3.80897C8 3.03319 7.3732 2.4043 6.60001 2.4043Z",
    fill: "#58486C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.675 18.2136C10.675 14.0142 14.0676 10.6121 18.25 10.6121C19.2314 10.6121 20.025 9.81412 20.025 8.83241C20.025 7.8507 19.2314 7.05273 18.25 7.05273C12.1046 7.05273 7.125 12.0508 7.125 18.2136C7.125 24.3765 12.1046 29.3746 18.25 29.3746C24.3953 29.3746 29.3749 24.3765 29.3749 18.2136C29.3749 17.2319 28.5814 16.434 27.5999 16.434C26.6184 16.434 25.8249 17.2319 25.8249 18.2136C25.8249 22.4131 22.4323 25.8152 18.25 25.8152C14.0676 25.8152 10.675 22.4131 10.675 18.2136Z",
    fill: "#58486C",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8622 7.77866C21.4255 8.31002 21.4529 9.19899 20.9233 9.76423L18.7923 12.0387C18.2627 12.6039 17.3767 12.6314 16.8133 12.1C16.25 11.5687 16.2226 10.6797 16.7522 10.1145L17.9243 8.86346L16.6775 7.68744C16.1141 7.15608 16.0867 6.26711 16.6163 5.70187C17.1459 5.13663 18.0319 5.10917 18.5953 5.64053L20.8622 7.77866Z",
    fill: "#58486C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6997 14.0508C16.9265 14.0508 16.2997 14.6797 16.2997 15.4555V19.8702C16.2997 20.357 16.551 20.8091 16.9637 21.065C17.3764 21.321 17.8918 21.3443 18.3258 21.1265L22.7258 18.9192C23.4174 18.5722 23.6977 17.7285 23.3519 17.0346C23.0061 16.3407 22.1652 16.0595 21.4736 16.4064L19.0997 17.5973V15.4555C19.0997 14.6797 18.4729 14.0508 17.6997 14.0508Z",
    fill: "#58486C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrookieJournal);
export default __webpack_public_path__ + "static/media/krookie-journal.edfc5a50df69965791ec2551fe1e1f78.svg";
export { ForwardRef as ReactComponent };